import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from './index.module.less';

export default function LockedComponent({
  onUnlock,
  customStyle,
}: {
  onUnlock: () => void;
  customStyle?: React.CSSProperties;
}) {
  const { t } = useTranslation();

  return (
    <div className={styles.lockedContainer} style={customStyle}>
      {/* 内容区域 */}
      <div className={styles.content}>
        <div className={styles.title}>{t("Don't Miss Out on Key Insights! 🔐 Unlock Full Results")}</div>
        <Button
          type="primary"
          className={styles.unlockButton}
          icon={<ViewIcon />}
          onClick={onUnlock}
          style={{
            background: 'linear-gradient(90deg, #428dff 0%, #ff47aa 100%)',
            border: 'none',
          }}
        >
          {t('Unlock Now')}
        </Button>
      </div>
    </div>
  );
}

// 眼睛图标
const ViewIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5 14.1667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V14.1667M17.5 5.83333V4.16667C17.5 3.72464 17.3244 3.30072 17.0118 2.98816C16.6993 2.67559 16.2754 2.5 15.8333 2.5H4.16667C3.72464 2.5 3.30072 2.67559 2.98816 2.98816C2.67559 3.30072 2.5 3.72464 2.5 4.16667V5.83333"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99935 10.8307C10.4596 10.8307 10.8327 10.4576 10.8327 9.9974C10.8327 9.53716 10.4596 9.16406 9.99935 9.16406C9.53911 9.16406 9.16602 9.53716 9.16602 9.9974C9.16602 10.4576 9.53911 10.8307 9.99935 10.8307Z"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.786 10.2744C15.8483 10.0963 15.8483 9.90242 15.786 9.72437C15.3169 8.57473 14.5159 7.59089 13.4852 6.89834C12.4546 6.2058 11.2411 5.83594 9.99936 5.83594C8.75767 5.83594 7.54411 6.2058 6.51348 6.89834C5.48286 7.59089 4.68187 8.57473 4.2127 9.72437C4.15045 9.90242 4.15045 10.0963 4.2127 10.2744C4.68187 11.424 5.48286 12.4079 6.51348 13.1004C7.54411 13.7929 8.75767 14.1628 9.99936 14.1628C11.2411 14.1628 12.4546 13.7929 13.4852 13.1004C14.5159 12.4079 15.3169 11.424 15.786 10.2744Z"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
